import { render } from "./ModalBox.vue?vue&type=template&id=23b9ca32"
import script from "./ModalBox.vue?vue&type=script&lang=js"
export * from "./ModalBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__